import { Component, Input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ICDADetailed } from 'src/app/interfaces/CDA/ICDADetailed';
import { IPatientDetailed } from 'src/app/interfaces/Detailed/IPatientDetailed';
import { IModule } from 'src/app/interfaces/IModule';
import { CDAService } from 'src/app/services/cda.service';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PatientService } from 'src/app/services/patient.service';
import { paths } from 'src/component-paths/component-paths';

@Component({
  selector: 'app-ips-view',
  templateUrl: './ips-view.component.html',
  styleUrls: ['./ips-view.component.css'],
  standalone: false,
})
export class IpsViewComponent {
  @Input() submenu?: IModule[];

  private destroy$ = new Subject<void>();

  isLoading: boolean = false;

  patientInfo?: IPatientDetailed;

  componentPaths = paths;

  data?: ICDADetailed;

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
    private readonly cdaService: CDAService
  ) {}

  ngOnInit() {
    this.isLoading = true;

    this.patientService.patientInfoSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((patientInfo?: IPatientDetailed) => {
        this.patientInfo = patientInfo;
      });

    this.cdaService.getCDA(this.patientService.patientIDsignal()).subscribe({
      next: (res) => {
        this.data = res.data;
        this.isLoading = false;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  ngOnDestroy() {
    // Unsubscribe from observables
    this.destroy$.next();
    this.destroy$.complete();
  }
}
